import {
    IPoint,
    IPointData
} from './index'
import {
    ICriterion,
    ICriterionData
} from '../../abstract'


export interface IStepData extends ICriterionData<string> {
    position?: number
    points?: IPointData[]
}

export interface IStep extends IStepData, ICriterion<string> {
    position: number
    points?: IPoint[]

    validate(): boolean
    update(data?: IStepData): void
}

export const STEP_NAME_MAX_LENGTH = 300
export const STEP_DESCRIPTION_MAX_LENGTH = 1000
